exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-switch.s-lg[data-v-7da14aef]{width:60px;height:25px;padding-top:1px}.vue-switch[data-v-7da14aef]:after{top:3px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7da14aef","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/checklist_Componentes/switch.vue
// module id = 2883
// module chunks = 0